import { Icon } from '@mui/material';

export function LoadingSpinner({ size = 'medium' }: { size?: 'small' | 'medium' | 'large' }) {
  return (
    <Icon
      fontSize={size}
      data-testid="progressbar"
      sx={{
        animation: 'spin 1s linear infinite',
        '@keyframes spin': {
          '0%': {
            transform: 'rotate(-360deg)',
          },
          '100%': {
            transform: 'rotate(0deg)',
          },
        },
      }}
    >
      <img src="/tradebyte/tb360/tb-360-icon.svg" alt="TB.360 Loading" />
    </Icon>
  );
}
